import React from 'react';
import classnames from 'classnames';
import css from './Error.module.css';
import { ReactComponent as Robot } from '../../../assets/imgs/robot.svg';

const Error = () => (
    <div
        data-testid="error-screen"
        className={classnames(css.root, 'container px-5')}
    >
        <div className={classnames(css.content)}>
            
            <Robot />

            <div className="mt-4" />

            <h1>Oops, there has been an error!</h1>


            <div className="mt-5" />

            <h2>Please go back and try again.</h2>

            <div className="mt-4" />

            <p>
          If you continue to receive this error, please contact our Support Team
          with details of the problem&nbsp;
                <a className={classnames(css.link)} href="mailto:helpdesk@lms.com">
            helpdesk@lms.com
                </a>
            </p>
        </div>
    </div>
);


export default Error;